
<template>
    
        <mars-view class="tags"><mars-view v-if="label" class="label c-gap-inner-top-large">
        {{ label }}
    </mars-view><mars-view class="tag-cont"><mars-view v-for="(option, optionIndex) in options" :key="optionIndex" use-trackby class="tag-i"><c-tag-item :text="option.text" :selected="option.selected" :border-radius="borderRadius" :primary-color="primaryColor" :background-color-selected="backgroundColorSelected" :selected-bold="selectedBold" :selected-icon="selectedIcon" @click.native="onItemTap({
                    optionIndex,
                    option
                })"></c-tag-item></mars-view></mars-view></mars-view>
    
</template>

<script>
import TagItem from "./TagItem.vue";
export default {
  components: {
    'c-tag-item': TagItem
  },
  props: {
    /**
     * 标签
     */
    label: String,

    /**
     * 选项们
     */
    options: Array,

    /**
     * 类型；radio 单选；checkbox 多选；
     */
    type: {
      type: String,
      default: 'radio'
    },

    /**
     * 圆角弧度
     */
    borderRadius: {
      type: String
    },

    /**
     * 主颜色
     */
    primaryColor: {
      type: String
    },

    /**
     * 被选中后的背景色
     */
    backgroundColorSelected: {
      type: String
    },

    /**
     * 选中后是否加粗
     */
    selectedBold: {
      type: Boolean
    },

    /**
     * 选中后是否显示图标
     */
    selectedIcon: {
      type: Boolean
    }
  },
  methods: {
    onItemTap(obj) {
      // 多选
      if (this.type === 'checkbox') {} // 单选


      obj.type = this.type;
      /**
       * 项点击事件
       *
       * @event itemtap
       *
       * @property {string} param1.type 类型
       * @property {number} param1.optionIndex 当前选中项索引
       * @property {object} param1.option 当前选中项
       */

      this.$emit('itemtap', obj);
    }

  }
};
</script>

<style scoped>
.tags {
  background-color: #fff;
}
.tag-cont {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin: 0 -5px;
}
.tag-i {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 7px 5px;
  width: 33.3%;
}
.label {
  padding-bottom: 11px;
  color: #000;
  font-weight: bold;
}
.row {
  padding-bottom: 8px;
}

</style>
